import type { ScheduleReadinessState } from './deriveScheduleReadiness';

const STORAGE_PREFIX = 'falcon-planner:schedule-readiness-dismissed:';

/** Session-scoped dismiss: returns on next browser session if gap remains. */
function storageKey(projectId: string, state: ScheduleReadinessState): string {
  return `${STORAGE_PREFIX}${projectId}:${state}`;
}

export function isScheduleReadinessDismissed(
  projectId: string,
  state: ScheduleReadinessState,
): boolean {
  if (typeof window === 'undefined' || !projectId || state === 'ready') return false;
  try {
    return window.sessionStorage.getItem(storageKey(projectId, state)) === '1';
  } catch {
    return false;
  }
}

export function dismissScheduleReadiness(
  projectId: string,
  state: ScheduleReadinessState,
): void {
  if (typeof window === 'undefined' || !projectId || state === 'ready') return;
  try {
    window.sessionStorage.setItem(storageKey(projectId, state), '1');
  } catch {
    // ignore quota / private mode
  }
}

/** Whether the readiness strip should render for this project + state. */
export function shouldShowScheduleReadiness(
  projectId: string,
  state: ScheduleReadinessState,
): boolean {
  if (!projectId || state === 'ready') return false;
  return !isScheduleReadinessDismissed(projectId, state);
}
